export enum ColorCode {
  DEFAULT = 'default',
  GREEN = 'green',
  AMBER = 'amber',
  RED = 'red',
}
